import { Link } from "react-router-dom";
import MediaFrame from "@/components/feature/MediaFrame";
import Reveal from "@/components/feature/Reveal";
import Breadcrumb from "@/components/feature/Breadcrumb";
import { clinic } from "@/mocks/clinic";

/**
 * /regenerative/stemsup-drip（StemSup点滴）専用HERO。
 * NOTE: 再生医療カテゴリの中心施術。幹細胞そのものを投与する治療であるかのような断定表現は使用しない。
 *       「幹細胞培養上清液」と「幹細胞そのもの」を明確に区別する。
 */
export default function StemSupDripHero() {
  return (
    <section className="relative overflow-hidden border-b border-background-300/70 bg-background-50 pb-16 pt-28 md:pb-20 md:pt-36 lg:pb-24 lg:pt-40">
      <div
        aria-hidden
        className="pointer-events-none absolute -right-24 top-24 h-72 w-72 rounded-full bg-secondary-100/50 blur-3xl"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -left-24 bottom-0 h-80 w-80 rounded-full border border-foreground-950/5"
      />
      <div
        aria-hidden
        className="pointer-events-none absolute -left-40 bottom-[-40px] h-[420px] w-[420px] rounded-full border border-foreground-950/5"
      />

      <div className="u-container relative">
        {/* 施術詳細：HOME ＞ 親カテゴリ ＞ 現在の施術（現在ページは非リンク） */}
        <Breadcrumb
          items={[
            { label: "HOME", href: "/", path: "/" },
            { label: "再生医療", href: "/treatment/regenerative", path: "/treatment/regenerative" },
            { label: "StemSup点滴", path: "/regenerative/stemsup-drip" },
          ]}
        />

        <div className="mt-10 grid grid-cols-1 gap-12 lg:mt-14 lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-16">
          <div>
            <Reveal>
              <span className="en-eyebrow block text-[11px] text-secondary-700 md:text-[12px]">
                REGENERATIVE MEDICINE
              </span>
              <span className="mt-5 block h-px w-12 bg-accent-500" />
              <h1 className="mt-7 font-heading text-[32px] leading-[1.5] tracking-[0.02em] text-foreground-950 md:text-[44px]">
                StemSup点滴
              </h1>
              <p className="mt-4 font-label text-[12px] tracking-[0.28em] text-foreground-500 md:text-[13px]">
                STEMSUP IV THERAPY
              </p>
              <p className="mt-8 font-heading text-[20px] leading-[1.9] text-foreground-900 md:text-[26px]">
                幹細胞培養上清液を、
                <br />
                点滴で投与するメニュー。
              </p>
              <p className="mt-6 text-[14px] leading-[2.2] text-foreground-700 md:text-[15px]">
                再生医療カテゴリでは、幹細胞を培養する過程で得られる幹細胞培養上清液 StemSupを、点滴で投与するメニューをご案内します。
                <br />
                本治療で使用するのは、幹細胞そのものではありません。
              </p>
            </Reveal>

            <Reveal delay={140}>
              <div className="mt-8 flex flex-wrap items-center gap-x-6 gap-y-3 text-[12px] text-foreground-600">
                <Link
                  to="/treatment/regenerative"
                  className="group inline-flex items-center gap-2 whitespace-nowrap text-foreground-800 transition-colors hover:text-accent-700"
                >
                  <i className="ri-arrow-left-line transition-transform group-hover:-translate-x-0.5" aria-hidden />
                  再生医療へ戻る
                </Link>
                <span className="hidden h-4 w-px bg-foreground-950/15 sm:block" />
                <span className="flex items-center gap-2">
                  <i className="ri-map-pin-line text-accent-700" aria-hidden />
                  渋谷駅近く
                </span>
                <span className="hidden h-4 w-px bg-foreground-950/15 sm:block" />
                <span className="flex items-center gap-2">
                  <i className="ri-time-line text-accent-700" aria-hidden />
                  診療時間 {clinic.hours}
                </span>
              </div>
            </Reveal>
          </div>

          <Reveal delay={120}>
            <MediaFrame
              src="/images/site/sbdc-stemsup-drip-fv-v1.webp"
              alt="渋谷美容皮膚科クリニックのStemSup点滴"
              tone="greige"
              objectPosition="object-center"
              className="aspect-[3/2] w-full"
            />
          </Reveal>
        </div>
      </div>
    </section>
  );
}